<template>
    <div id="articles" class="c frame bg-default c-articles">
        <div class="container">
            <div class="c-filter__backdrop" @click="closeFilter"></div>
            <div class="c-filter">
                <div class="c-filter__label">{{ overviewSettings.FilterTitle }}</div>
                <div class="c-filter__items">
                    <template v-if="isLoading">
                        <div class="c-filter__item">
                            <div class="c-filter__item--btn">
                                <span class="c-filter__item--btn--name">{{ getFilterName('Sector') }}</span> <span class="c-filter__item--btn--amount">(0)</span>
                            </div>
                        </div>
                        <div v-if="overviewSettings.IndexName !== 'agruniek-specialists'" class="c-filter__item">
                            <div class="c-filter__item--btn">
                                <span class="c-filter__item--btn--name">{{ getFilterName('Theme') }}</span> <span class="c-filter__item--btn--amount">(0)</span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="(filter, filterName) in facets" :key="filterName" class="c-filter__item">
                            <button :class="['c-filter__item--btn', { active: openFilter === filterName }]" type="button" :data-filtername="filterName" @click="toggleFilter">
                                <span class="c-filter__item--btn--name">{{ getFilterName(filterName) }}</span>
                                <span :class="['c-filter__item--btn--amount', { shown: checkedFacetsCount(filterName) > 0 }]">({{ checkedFacetsCount(filterName) }})</span>
                            </button>
                            <ul class="c-filter__item--list">
                                <li v-for="(filterItem, filterIndex) in filter" :key="filterIndex" :class="{ lvl2: filterItem.value.includes('.'), active: isFilterValueChecked(filterName, filterItem.value) }">
                                    <input
                                        :id="'filter-' + filterName + '-' + filterIndex"
                                        type="checkbox"
                                        :value="filterItem.value"
                                        :checked="isFilterValueChecked(filterName, filterItem.value)"
                                        @change="updateFilters($event, filterName)"
                                    />
                                    <label :for="'filter-' + filterName + '-' + filterIndex">{{ getSectorName(filterItem.value) }} ({{ filterItem.count }})</label>
                                </li>
                            </ul>
                        </div>
                        <div v-show="checkedFacets['Sector'] != null || checkedFacets['Theme'] != null" class="c-filter__item">
                            <button type="button" class="c-filter__item--reset" @click="resetFilters">{{ overviewSettings.FilterReset }}</button>
                        </div>
                    </template>
                </div>
            </div>
            <template v-if="overviewSettings.IndexName === 'agruniek-specialists'">
                <div class="c-specialists__inner">
                    <div class="row">
                        <template v-if="isLoading">
                            <div v-for="placeholder in parseInt(overviewSettings.PlaceholderCount)" :key="placeholder" class="c col-12 col-sm-6 col-lg-4 col-xl-3">
                                <div class="c-specialists__item c-placeholder is-loading"></div>
                            </div>
                        </template>
                        <specialistItem v-for="resultItem in searchResults" v-else :key="resultItem.DocumentGuid" :result-item="resultItem" :translations="overviewSettings.Translations" />
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="c c-articles__overview">
                    <template v-if="isLoading">
                        <div v-for="placeholder in parseInt(overviewSettings.PlaceholderCount)" :key="placeholder" class="c-articles__overview--card">
                            <div class="c-articles__item c-placeholder is-loading"></div>
                        </div>
                    </template>
                    <template v-for="resultItem in searchResults" v-else>
                        <div v-if="resultItem.ArticleType === 'Product'" :key="resultItem.DocumentGuid" class="c-articles__overview--card">
                            <div class="c-concepts__item">
                                <div class="c-concepts__item--image">
                                    <div class="c-concepts__item--image--img">
                                        <template v-if="resultItem.PhotoUrl !== null && resultItem.PhotoUrl !== ''">
                                            <img :src="resultItem.PhotoUrl" :alt="resultItem.Title" class="img-fluid" loading="lazy" />
                                        </template>
                                        <template v-else>
                                            <img src="/assets/images/noimage-315x210.svg" :alt="resultItem.Title" class="img-fluid" loading="lazy" />
                                        </template>
                                    </div>
                                </div>
                                <div class="c-concepts__item--inner">
                                    <h3>{{ resultItem.Title }}</h3>
                                    <p>{{ resultItem.Intro }}</p>
                                    <a class="btn btn-link stretched-link" :href="resultItem.DocumentUrl" :title="resultItem.Title"><span>Lees meer</span><i class="fal fa-arrow-right"></i></a>
                                </div>
                            </div>
                        </div>
                        <div v-else :key="resultItem.DocumentGuid" class="c-articles__overview--card">
                            <a :class="['c-articles__item', resultItem.PhotoUrl !== null && resultItem.PhotoUrl !== '' ? 'has-image' : 'no-image']" :href="resultItem.DocumentUrl" :title="resultItem.Title">
                                <div v-if="resultItem.PhotoUrl !== null && resultItem.PhotoUrl !== ''" class="c-articles__image">
                                    <img :src="resultItem.PhotoUrl" :alt="resultItem.Title" class="c-articles__image--img" loading="lazy" />
                                </div>
                                <div class="c-articles__labels c-labels">
                                    <div v-if="resultItem.SectorLabel !== null" class="c-labels__lbl" data-type="sector">{{ resultItem.SectorLabel }}</div>
                                    <div v-for="sector in resultItem.Sector.filter((sector) => sector.includes('.') != true)" v-else :key="sector" class="c-labels__lbl" data-type="sector">{{ sector }}</div>
                                    <div v-for="theme in resultItem.Theme" :key="theme" class="c-labels__lbl" data-type="theme">{{ theme }}</div>
                                </div>
                                <div class="c-articles__inner">
                                    <div v-if="showDate(resultItem.ArticleType)" class="c-articles__date">{{ getPresentationDate(resultItem.DocumentDate) }}</div>
                                    <div class="h3 c-articles__title">{{ resultItem.Title }}</div>
                                    <div class="c-articles__text">
                                        <p>{{ resultItem.Intro }}</p>
                                        <div class="c-articles__readmore"><span>Lees verder</span><i class="fal fa-arrow-right"></i></div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </template>
                </div>
            </template>
            <paginationControlls :pageCount="pageCount" :hasPreviousPage="hasPreviousPage" :currentPage="currentPage" :hasNextPage="hasNextPage"/>
        </div>
    </div>	
</template>
<script>
    import specialistItem from './specialistItem.vue';
    import paginationControlls from './paginationControlls.vue';
    export default {    
        components: {
		    specialistItem,
		    paginationControlls
	    },
        props: [ 
            'checkedFacets',
            'facets',
            'overviewSettings',
            'isLoading',
            'pageCount',
            'hasPreviousPage',
            'currentPage',
            'hasNextPage',
            'openFilter',
            'searchResults',
        ],
        methods:{
            getSectorName: function (name) {
                return this.$parent.getSectorName(name);
            },
            getFilterName: function (name) {
                return this.$parent.getFilterName(name);
            },
            updateFilters: function (event, filtertype) {
                this.$parent.updateFilters(event,filtertype);
            },
            checkedFacetsCount: function (key) {
                return this.$parent.checkedFacetsCount(key);
            },
            resetFilters: function (event) {
                this.$parent.resetFilters(event);
            },
            isFilterValueChecked: function (facet, value) {
                return this.$parent.isFilterValueChecked(facet,value);
            },
            toggleFilter: function (event) {
                this.$parent.toggleFilter(event);
            },
            closeFilter: function () {
                this.$parent.closeFilter();
            },
            getPresentationDate: function(dateString){
                return this.$parent.getPresentationDate(dateString);
            },
            showDate: function(item){
                return this.$parent.showDate(item);
            },
            previousPage(){
                this.$parent.previousPage();
            },
            setCurrentPageByEvent($event){
                this.$parent.setCurrentPageByEvent($event);
            },
            nextPage(){
                this.$parent.nextPage();
            },
        }
    };
    </script>
    